<div class="password-strength-meter" *ngIf="HasValue">
    <div class="bars">
        <span class="bar" *ngFor="let i of [0, 1, 2]" [class.filled]="i < FilledBars" [ngClass]="Level"></span>
    </div>
    <!-- <span class="label" [ngClass]="Level">{{ Label }}</span> -->
</div>
